export default "__VITE_ASSET__CjyF3b0g__"